import { render, staticRenderFns } from "./PatientCost.vue?vue&type=template&id=59c6caf5&scoped=true"
import script from "./PatientCost.vue?vue&type=script&lang=js"
export * from "./PatientCost.vue?vue&type=script&lang=js"
import style0 from "./PatientCost.vue?vue&type=style&index=0&id=59c6caf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6caf5",
  null
  
)

export default component.exports